import type { Migration } from "./Migration";
import { defaultFeatures } from "../features.store";

const migration: Migration = {
  applyToVersions: "<6.0.0",
  type: "before",
  name: "update available features",
  migrate: (data: { features?: { [key: string]: boolean | undefined } }) => {
    const features = data?.features;
    if (!features) return data;

    const undefinedFeatures = Object.keys(features).filter(
      (featureName) => features[featureName] == undefined
    );

    const _defaultFeatures = defaultFeatures as {
      [key: string]: boolean | undefined;
    };

    // If one of the undefined features moved to the
    // default features (is stable now), we need to set it to true.
    const newFeatures = undefinedFeatures.filter(
      (featureName) => _defaultFeatures[featureName] === true
    );
    newFeatures.forEach((featureName) => {
      features[featureName] = true;
    });

    return data;
  }
};

export default migration;
